import React from 'react';
import { NavLink } from "react-router-dom";

import { recipesData } from '../data/recipes.json';

const Recipes = () => {

  return (
    <div className="recipesPage">
      <div className="reciptesTopheading">
        <h1>RECIPES</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
      </div>
      <ul>
        {
          recipesData.map((recipeItem) => (
            <li>
              <div className="recipesCard"></div>
              <p>{recipeItem.name}</p>

              <NavLink exact to={{
                pathname: "/recipeitem",
                data: recipeItem
              }}>
                <button>View Recipe</button>
              </NavLink>
            </li>
          ))
        }
      </ul>

      <div className="recipesViewMore">
        <button>See more</button>
      </div>
    </div>
  );
}

export default Recipes;
